import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/documentationrule"

const serviceName = "DocumentationRule-Service: ";
export default class DocumentationRuleService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static postToAPI(docuRule, successF, errorF) {
    WrapperService.post(API_URL, docuRule, serviceName, successF, errorF)
  }

  static putToAPI(docuRule, successF, errorF) {
    WrapperService.put(API_URL + "/" + docuRule.id, docuRule, serviceName, successF, errorF)
  }

  static deleteFromAPI(docuRule, successF, errorF) {
    WrapperService.delete(API_URL + "/" + docuRule.id, serviceName, successF, errorF)
  }
}